<template>
	<nuxt-link
		v-if="magazine"
		:id="magazine.uuid"
		:to="'/' + magazine.full_slug"
		:aria-label="magazine.content?.title"
		class="flex flex-col items-start space-y-md md:space-y-0"
	>
		<nuxt-picture
			v-if="magazine.content?.image?.filename"
			:src="magazine.content?.image?.filename"
			:alt="magazine.content?.image?.alt ?? magazine.content?.title"
			class="w-full md:aspect-square"
			loading="lazy"
			height="330"
			width="330"
			provider="storyblok"
			sizes="xs:245px sm:608px md:245px lg:330px xl:416px 2xl:501px"
			:img-attrs="{
				class: 'rounded-2xs object-cover w-full h-full',
			}"
		/>

		<div class="pt-sm">
			<p class="text-xs tracking-3xl text-gray-500">
				{{ localDate(magazine.created_at) }}
			</p>

			<v-h5 class="leading-6">
				{{ magazine.content?.title }}
			</v-h5>
		</div>
	</nuxt-link>
</template>

<script setup lang="ts">
import type {ISbStoryData} from "storyblok-js-client";

defineProps<{
	magazine: ISbStoryData;
}>();

function localDate(date: string) {
	return new Date(date).toLocaleDateString("fi-FI");
}
</script>
